<template>
  <BaseModal
    ref="baseModalRef"
    :title="'Órdenes de Misión'"
    modal-id="orders"
    :isVisible="true"
    @close="closeDialog"
    @minimize="$emit('minimize', 'orders')"
    @restore="$emit('restore', 'orders')"
  >
    <div id="buscador" class="form">
      <div class="container-fluid">
        <div class="form events-window">
          <h5 class="col-12 ml-0">
            <div class="filters-show" @click="toggleFilters" style="cursor: pointer">
              <i :class="showFilters ? 'bi bi-caret-up-fill' : 'bi bi-caret-down-fill'"></i>
              <i class="bi bi-funnel"></i> Filtrar
            </div>
          </h5>

          <!-- INICIO FILTROS -->
          <div v-if="showFilters" class="row filter-box col-12">
            <div class="col-4 col-6-small">
              <!-- Generico fechas -->
              <div class="filter-group">
                <div class="form-check">
                  <select
                    class="form-select select-tiempo form-select-sm"
                    aria-label="Default select example"
                    @change="handleGenericDateChange"
                  >
                    <option selected>Siempre</option>
                    <option value="1">Hoy</option>
                    <option value="2">Este mes</option>
                    <option value="3">Este año</option>
                    <option value="4">Ultimos 7 dias</option>
                    <option value="5">Ultimos 15 dias</option>
                    <option value="6">Ultimos 30 dias</option>
                  </select>
                </div>
              </div>
            </div>
            <div class="col-4 col-6-small">
              <!-- FECHA DESDE -->
              <div class="filter-group">
                <div class="form-check">
                  <input
                    class="form-check-input"
                    type="checkbox"
                    value=""
                    id="showStartDate"
                    v-model="filters.showStartDate"
                    @change="callApi"
                  />
                  <label class="form-check-label" for="flexCheckDefault"> Desde </label>
                </div>
                <div v-if="filters.showStartDate" class="active-filter">
                  <input
                    type="date"
                    v-model="filters.start_date"
                    @change="callApi"
                    class="form-control"
                  />
                </div>
              </div>
            </div>

            <div class="col-4 col-6-small">
              <!-- FECHA HASTA -->
              <div class="filter-group">
                <div class="form-check">
                  <input
                    class="form-check-input"
                    type="checkbox"
                    value=""
                    id="showEndDate"
                    v-model="filters.showEndDate"
                    @change="callApi"
                  />
                  <label class="form-check-label" for="flexCheckDefault"> Hasta </label>
                </div>
                <div v-if="filters.showEndDate" class="active-filter">
                  <input
                    type="date"
                    v-model="filters.end_date"
                    @change="callApi"
                    class="form-control"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="row list-box">
          <div class="col-list">
            <div class="text-center">
              <label class="reports-title"
                >Reportes Filtrados <span class="count-badge">({{ cantidadReports }})</span></label
              >
            </div>

            <!-- Lista responsive de reportes -->
            <div class="reports-list-container" style="height: 100%">
              <div
                v-for="report in reportFiles"
                :key="report.report_id"
                class="report-item"
                :class="{ selected: selectedReport?.report_id === report.report_id }"
                @click="changeReport(report)"
              >
                <div class="report-item-content">
                  <!-- Solo nombre del reporte -->
                  <div class="report-name">{{ report.name }}</div>
                  <div
                    v-if="selectedReport?.report_id === report.report_id"
                    class="selection-indicator"
                  >
                    <i class="bi bi-check-circle-fill"></i>
                  </div>
                </div>
              </div>

              <!-- Mensaje cuando no hay reportes -->
              <div v-if="reportFiles.length === 0" class="no-reports">
                <i class="bi bi-file-earmark-text"></i>
                <p>No se encontraron reportes</p>
              </div>
            </div>
          </div>

          <div class="datos-report">
            <h5 class="my-3">{{ selectedReport.name }}</h5>
            <h5 class="my-3">{{ selectedReport.utc.replace('T', ' ') }}</h5>
            <div ref="imageContainer" class="report-container">
              <iframe
                class="frame-report"
                :src="
                  '/fserver/documents/reports/' +
                  selectedReport.type.trim() +
                  selectedReport.type_version.trim() +
                  '/' +
                  getYearMonth(selectedReport.utc) +
                  '/' +
                  selectedReport.pdf_name.replace('Stills', 'stills').replace('\\', '/')
                "
                width="100%"
                style="border: none"
              ></iframe>
              <button @click="toggleFullScreen" class="btn btn-secondary btn-sm me-1 d-block">
                Ampliar a Pantalla Completa
              </button>
              <button @click="gotoRelated" class="btn btn-secondary btn-sm d-block">
                Ir a {{ selectedReport.type === 'RM' ? 'OM' : 'ROA' }}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </BaseModal>
</template>
<script setup lang="ts">
import { ref, defineEmits, onMounted, watch } from 'vue'
import BaseModal from './base/BaseModal.vue'
import type { ReportFile } from '../types'
import API from '../services'
import { AxiosError } from 'axios'
import FiltroFechas from './base/FiltroFechas.vue'
import { useGlobalStore } from '@/stores/global'
import { storeToRefs } from 'pinia'

const reportFiles = ref<ReportFile[]>([])
const cantidadReports = ref(0)
const selectedReport = ref<ReportFile>({
  number: '48324',
  creator: 'Bernardo',
  utc: '2024-11-28T13:07:22.201-03:00',
  report_id: '2244',
  file_name: '',
  pdf_name: '',
  mission_plan_id: '-1',
  origin: 'LA  ',
  name: '',
  type: 'OM',
  type_version: '1.0',
  link_id: '30',
  mission: 0
})
const globals = useGlobalStore()
const { missionPlan, viewCurrentMissionPlan } = storeToRefs(globals)
const startDate = ref<string>('')
const endDate = ref<string>('')
const reportType = ref<string>('OM')

const imageContainer = ref<HTMLElement | null>(null)

const emit = defineEmits<{
  (event: 'closed'): void
  (event: 'minimize', modalId: string): void
  (event: 'restore', modalId: string): void
  (event: 'gotoRelated', report: ReportFile): void
}>()
watch([startDate, endDate, reportType], () => {
  callApi()
})
const showFilters = ref(false) // Controla la visibilidad de filter-box
const baseModalRef = ref()

const filters = ref({
  showStartDate: false,
  showEndDate: false,
  start_date: '',
  end_date: ''
})

defineExpose({
  restoreModal: () => {
    if (baseModalRef.value) {
      baseModalRef.value.restoreModal()
    }
  }
})
const props = defineProps<{
  viewReport: ReportFile | null;
}>();

watch(
  () => props.viewReport,
  (newReport) => {
    if (newReport) {
      changeReport(newReport);
    }
  },
  { immediate: true } // Ejecutar el watch inmediatamente al montar el componente
);
function gotoRelated() {
  relatedReport(
    selectedReport.value.mission.toString(),
    selectedReport.value.type === 'RM' ? 'OM' : 'RM'
  )
  if (selectedReport.value.type === 'OM') {
    viewCurrentMissionPlan.value = false
  } else {
    viewCurrentMissionPlan.value = true
  }
}
function closeDialog() {
  emit('closed')
}
function changeReport(report: ReportFile) {
  selectedReport.value = report
  if (selectedReport.value.type === 'OM') {
    getMissionPlanByPlanId(selectedReport.value.mission_plan_id)
    viewCurrentMissionPlan.value = true
  } else {
    missionPlan.value = null
  }
}
onMounted(() => {
  callApi()
})
function getYearMonth(utc: string): string {
  // Extrae los primeros 7 caracteres: "2025-01"
  return utc.substring(0, 7).replace('-', '/')
}
async function callApi() {
  const filters = {
    start_date: startDate.value.replace(/-/g, ''),
    end_date: endDate.value.replace(/-/g, ''),
    type: reportType.value === 'Todos' ? undefined : reportType.value
  }
  try {
    const { status, data } = await API.listReportFiles(filters)

    if (status == 200) {
      reportFiles.value = data.Entries.Entry
      cantidadReports.value = reportFiles.value.length
    } else {
      reportFiles.value = []
      cantidadReports.value = 0
    }
  } catch (error) {
    const _error = error as AxiosError<string>
    console.error(_error.message)
    reportFiles.value = []
    cantidadReports.value = 0
  }
}
async function relatedReport(mission: string, reportType: string) {
  const filters = {
    type: reportType,
    mission: mission
  }
  try {
    const { status, data } = await API.listReportFiles(filters)

    if (status == 200) {
      emit('gotoRelated', data.Entries.Entry[0])
    }
  } catch (error) {
    const _error = error as AxiosError<string>
    console.error(_error.message)
  }
}

function toggleFullScreen() {
  if (!document.fullscreenElement) {
    imageContainer.value?.requestFullscreen().catch((err: Error) => {
      alert(`Error al intentar entrar en modo de pantalla completa: ${err.message} (${err.name})`)
    })
  } else {
    document.exitFullscreen()
  }
}

function toggleFilters() {
  showFilters.value = !showFilters.value
}

function handleGenericDateChange(event: Event) {
  const value = (event.target as HTMLSelectElement).value
  const today = new Date()
  let startDate = ''
  let endDate = today.toISOString().slice(0, 10) // formato YYYY-MM-DD

  switch (value) {
    case '1': // Hoy
      startDate = endDate
      break
    case '2': // Este mes
      startDate = new Date(today.getFullYear(), today.getMonth(), 1).toISOString().slice(0, 10)
      break
    case '3': // Este año
      startDate = new Date(today.getFullYear(), 0, 1).toISOString().slice(0, 10)
      break
    case '4': // Últimos 7 días
      startDate = new Date(today.getTime() - 6 * 24 * 60 * 60 * 1000).toISOString().slice(0, 10)
      break
    case '5': // Últimos 15 días
      startDate = new Date(today.getTime() - 14 * 24 * 60 * 60 * 1000).toISOString().slice(0, 10)
      break
    case '6': // Últimos 30 días
      startDate = new Date(today.getTime() - 29 * 24 * 60 * 60 * 1000).toISOString().slice(0, 10)
      break
    default:
      // Siempre: limpiar fechas y ocultar
      filters.value.showStartDate = false
      filters.value.showEndDate = false
      filters.value.start_date = ''
      filters.value.end_date = ''
      callApi()
      return
  }

  filters.value.showStartDate = true
  filters.value.showEndDate = true
  filters.value.start_date = startDate
  filters.value.end_date = endDate
  callApi()
}
async function getMissionPlanByPlanId(planId: string) {
  try {
    if (planId) {
      // Luego obtener el plan completo usando getMissionPlan
      console.log('📥 Obteniendo detalles del plan:', planId)
      const { status, data } = await API.getMissionPlan(planId)

      if (status === 200) {
        missionPlan.value = data
        console.log('✅ Plan de misión cargado:', data)
        return data
      } else {
        console.error('❌ Error obteniendo detalles del plan')
        missionPlan.value = null
        return null
      }
    } else {
      console.warn('⚠️ No se encontró plan_id para la misión')
      missionPlan.value = null
      return null
    }
  } catch (error) {
    console.error('❌ Error en getMissionPlanByMissionId:', error)
    missionPlan.value = null
    return null
  }
}

</script>

<style lang="css" scoped>
input,
.form-select label {
  max-width: 100%;
}

.filters-small .tipo {
  height: 30px;
}

.table-wrapper {
  overflow-y: scroll;
  height: 80vh;
}

.modal-container {
  min-width: 490px;
  width: 500px;
  height: 450px;
  min-height: 330px;
  max-height: 85vh;
}

.form-select {
  font-size: 12px;
  background-color: rgba(255, 255, 255, 0.2);
  scrollbar-color: white rgba(255, 255, 255, 0.3);
  max-height: 100%;
}

.row,
.col-10 {
  padding-right: 0%;
  justify-content: space-evenly;
}

h5 {
  height: max-content;
}

input,
.form-select label {
  max-width: 100%;
}

input.form-text-input,
input.form-number-input,
label.form-text-label {
  font-size: 12px;
}

.form,
.container-fluid,
.col-2,
.col-5 {
  height: 100%;
}

.report-container {
  width: 100%;
  height: calc(100% - 150px);
  position: relative;
}

.frame-report {
  width: 100%;
  height: 100%;
  border: none;
}

/* Estilos para la lista de reportes */
.reports-title {
  font-weight: 600;
  color: white;
  font-size: 14px;
}

.count-badge {
  background: rgba(255, 255, 255, 0.2);
  padding: 2px 8px;
  border-radius: 12px;
  font-size: 12px;
}

.reports-list-container {
  max-height: 300px;
  overflow-y: auto;
  border: 1px solid #eee;
  border-radius: 4px;
  font-size: 12px;
  background-color: rgba(255, 255, 255, 0.2);
  scrollbar-color: white rgba(255, 255, 255, 0.3);
  max-height: 100%;
  padding-left: 10px;
  padding-right: 10px;
}

.reports-list-container::-webkit-scrollbar {
  width: 6px;
}

.reports-list-container::-webkit-scrollbar-track {
  background: transparent;
}

.reports-list-container::-webkit-scrollbar-thumb {
  background: rgba(255, 255, 255, 0.3);
  border-radius: 3px;
}

.report-item {
  margin-bottom: 6px;
  border-radius: 6px;
  transition: all 0.2s ease;
  cursor: pointer;
  background: rgba(255, 255, 255, 0.05);
  border: 1px solid transparent;
}

.report-item:hover {
  background: rgba(255, 255, 255, 0.15);
  border-color: rgba(255, 255, 255, 0.3);
  transform: translateY(-1px);
}

.report-item.selected {
  background: rgba(91, 161, 223, 0.3);
  border-color: #5ba1df;
  box-shadow: 0 2px 8px rgba(91, 161, 223, 0.3);
}

.report-item-content {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px 12px;
  position: relative;
}

.report-name {
  flex: 1;
  font-size: 12px;
  font-weight: 500;
  color: white;
  word-break: break-word;
  line-height: 1.3;
  min-width: 0;
}

.selection-indicator {
  color: #5ba1df;
  font-size: 16px;
  margin-left: 8px;
  flex-shrink: 0;
}

.no-reports {
  text-align: center;
  padding: 40px 20px;
  color: rgba(255, 255, 255, 0.5);
}

.no-reports i {
  font-size: 48px;
  margin-bottom: 16px;
  display: block;
}

.no-reports p {
  margin: 0;
  font-size: 14px;
}

.events-window {
  margin: 0px 10px;
  margin-top: 0px;
  --bs-gutter-y: 0;
  display: flex;
  flex-wrap: wrap;
  flex-shrink: 0;
  width: 100%;
  height: max-content;
}

@media (max-width: 576px) {
  .modal-container-small {
    max-width: 90vw;
    min-width: 200px;
    width: 90vw;
    height: 480px;
    min-height: 400px;
  }

  .col-2 {
    height: fit-content;
  }

  .col-3 {
    height: 200px;
  }

  .col-5 {
    width: 100%;
    margin-top: 30px;
  }
}

.filter-box .form-check {
  display: inline-block;
  width: auto;
  margin-right: 10px;
  min-height: fit-content;
}
.filter-box {
  border: 0px solid white;
  border-radius: 5px;
  background-color: rgba(255, 255, 255, 0.1);
  font-size: 12px;
  padding: 5px;
  margin: 0;
}

.fltr-btn {
  font-size: 12px;
  margin-top: 5px;
  margin-bottom: 5px;
}

.active-filter {
  padding: 2px;
  border: 1px solid #6c757d;
  /* Borde azul */
  border-radius: 10px;
}

.filters-show {
  text-decoration: underline;
  margin-top: 10px;
}

.filters-show:hover {
  color: #6c757d;
  text-decoration: none;
  cursor: pointer;
}

.list-box {
  height: calc(100% - 60px);
}
</style>
